import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse, ChatDetail, ChatSummary, TranslateDocumentRequest } from '../../../core/models/api.models';
import { AuthenticatedHttpService } from '../../../core/http/authenticated-http.service';

@Injectable({ providedIn: 'root' })
export class ChatApiService {
  private readonly http = inject(AuthenticatedHttpService);
  private readonly baseUrl = `${environment.apiUrl}/Chats`;
  list(): Observable<ApiResponse<ChatSummary[]>> { return this.http.get(`${this.baseUrl}`); }
  detail(id: string): Observable<ApiResponse<ChatDetail>> { return this.http.get(`${this.baseUrl}/${id}`); }
  delete(id: string): Observable<ApiResponse<unknown>> { return this.http.delete(`${this.baseUrl}/${id}`); }
  like(chatId: string, messageId: string): Observable<ApiResponse<unknown>> { return this.http.get(`${this.baseUrl}/like/${chatId}/${messageId}`); }
  dislike(chatId: string, messageId: string): Observable<ApiResponse<unknown>> { return this.http.get(`${this.baseUrl}/dislike/${chatId}/${messageId}`); }
  download(chunkId: string, documentId: string): Observable<ApiResponse<string>> {
    // Ordem comprovada na UI legada. TODO: validar nomes formais dos argumentos no backend.
    return this.http.get(`${this.baseUrl}/download/${chunkId}/${documentId}`);
  }
  translateDocument(request: TranslateDocumentRequest): Observable<ApiResponse<string>> {
    return this.http.post(`${environment.apiUrl}/Translate`, request);
  }
  legacyCreate(payload: unknown): Observable<ApiResponse<unknown>> { return this.http.post(this.baseUrl, payload); }
}
